<template>
  <div class="color-selection">
    <p class="h3 mb-2 pt-2 pb-4">Sélectionnez la couleur adaptée à votre intérieur</p>

    <div class="row two-parts">
      <div class="col-lg-7">
        <ul class="list-unstyled">
          <li>
            <img class="w-100" :src="require('@/assets/img/radiateurs/'+the_image(state.selected_config.radiatorsFetched[0]))">
          </li>
        </ul>
      </div>
      <div class="col-lg-5 pl-md-4 pr-md-0 d-flex flex-column justify-content-center">

        <div class="color-list mb-0">
          <div class="form-check pl-0 mb-4" v-for="(color,i) in colors" :key="i" @click="setDataRad('color',color)" v-if="!state.selected_config.excluded||state.selected_config.excluded&&!state.selected_config.excluded.includes(color.class)">
            <input class="form-check-input d-none" type="radio" name="colors" :id="'color-'+i" :value="'option'+i" :checked="state.radiator.color&&state.radiator.color.name==color.name">
            <label class="form-check-label" :for="'color-'+i">
              <div class="color-pellet pellet-lg" :class="color.class"><i class="far fa-check fa-lg" :class="color.checkColor"></i></div>
              <span class="text-secondary d-block text-center px-2">{{ color.name }}<sup class="text-danger"
             v-if="color.class=='degrade-blanc-reflet'||color.class=='degrade-anthracite'||color.class=='degrade-miroir'">*</sup></span>
            </label>
          </div>
        </div>
        <small class="d-block mb-3 text-secondary"><sup class="text-danger">*</sup> : Couleurs disponibles en finition brillant uniquement</small>
        <div class="alert alert-secondary rounded border-0 d-flex" role="alert">
          <i class="far fa-info-circle mr-2 pt-1"></i> 
          <span>Le choix de la couleur est globale aux radiateurs
<!--            , mais vous pourrez la changer indépendamment à la fin de la configuration.-->
          </span>
        </div>

        <router-link tag='button' :to="{name:routerTo}" class="btn btn-md btn-primary rounded-pill" :disabled="!state.radiator.color">
          Étape suivante
        </router-link>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ColorSelection",
  mounted(){
    if (this.state.radiator.orientation=='horizontal'||this.state.room_type=='sejour'||this.state.room_type=='chambre')this.setDataRad('towelDryers','0')
  },
  data(){
    return {
      colors:[
        {
          name:'Beige',
          class:'degrade-beige',
          checkColor:'text-black',
        },{
          name:'Noir',
          class:'degrade-noir',
          checkColor:'text-white',
        },{
          name:'Miroir',
          class:'degrade-miroir',
          checkColor:'text-black',
        },{
          name:'Blanc reflet vert',
          class:'degrade-blanc-reflet',
          checkColor:'text-black',
        },{
          name:'Gris anthracite',
          class:'degrade-anthracite',
          checkColor:'text-white',
        },{
          name:'Extra blanc',
          class:'degrade-extra-blanc',
          checkColor:'text-black',
        },
      ],
    }
  },
  computed:{
    routerTo(){
      if (this.state.radiator.color&&(this.state.radiator.color.class=='degrade-blanc-reflet'||this.state.radiator.color.class=='degrade-anthracite'||this.state.radiator.color.class=='degrade-miroir')){
        this.setDataRad('finition','Brillant')
        return 'ThermostatSelection'
      }
      else return 'FinitionSelection'
    },
  }
}
</script>

<style scoped>

</style>
